import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MdKeyboardArrowDown from 'react-icons/lib/md/keyboard-arrow-down';

import css from '../styles/loadmore';

class LoadMore extends Component {
    static propTypes = {
        loading: PropTypes.bool,
        onClick: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this._onClick = () => {
            const { onClick, loading } = this.props;

            if (!onClick || loading) return;

            this.props.onClick();
        };
    }

    render() {
        const { loading } = this.props;

        const className = loading ? css.loading : css.container;

        return (
            <div
                className={className}
                onClick={this._onClick}
            ><MdKeyboardArrowDown /></div>
        );
    }
}

export default LoadMore;



/** WEBPACK FOOTER **
 ** /src/shared/components/LoadMore.js
 **/